import { useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";
import { PortalLoading, useCandidateAuth } from "./useCandidateAuth";

const TABS = [
    { label: "Overview", href: "/account" },
    { label: "Profile", href: "/account/profile" },
    { label: "Applications", href: "/account/applications" },
    { label: "Saved Jobs", href: "/account/saved" },
    { label: "Job Alerts", href: "/account/alerts" },
    { label: "Settings", href: "/account/settings" },
];

export const AccountLayout = ({ title, subtitle, children }) => {
    const { user, logout } = useCandidateAuth();
    const { pathname } = useLocation();

    if (!user) return <PortalLoading />;

    return (
        <div className="min-h-screen bg-ivory text-ink">
            <header className="border-b border-ink/10 bg-ivory">
                <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-6 gap-y-4 px-6 py-5 lg:px-10">
                    <div className="flex items-center gap-3.5">
                        <a href="/" data-testid="portal-home-link" className="flex h-10 w-10 items-center justify-center bg-forest font-serif text-xs font-semibold tracking-[0.12em] text-ivory">
                            AGL
                        </a>
                        <div className="leading-tight">
                            <p className="font-serif text-lg font-semibold tracking-tight">Candidate Portal</p>
                            <p className="text-[10px] uppercase tracking-[0.28em] text-ink/45">{user.email}</p>
                        </div>
                    </div>
                    <button
                        type="button"
                        data-testid="portal-logout-button"
                        onClick={logout}
                        className="inline-flex items-center gap-2 whitespace-nowrap border border-ink/20 px-4 py-2 text-xs font-medium uppercase tracking-[0.14em] text-ink/70 transition-colors hover:border-forest hover:text-forest"
                    >
                        <LogOut size={14} strokeWidth={1.5} />
                        Sign Out
                    </button>
                </div>
                <nav data-testid="portal-nav" className="border-t border-ink/10">
                    <div className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-6 lg:px-10">
                        {TABS.map((tab) => (
                            <a
                                key={tab.href}
                                href={tab.href}
                                data-testid={`portal-tab-${tab.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className={`whitespace-nowrap px-4 py-3.5 text-xs font-semibold uppercase tracking-[0.14em] transition-colors ${
                                    pathname === tab.href
                                        ? "border-b-2 border-forest text-forest"
                                        : "text-ink/55 hover:text-forest"
                                }`}
                            >
                                {tab.label}
                            </a>
                        ))}
                    </div>
                </nav>
            </header>

            <main className="mx-auto max-w-7xl px-6 py-10 lg:px-10">
                <h1 className="font-serif text-3xl font-medium tracking-tight">{title}</h1>
                {subtitle && <p className="mt-1 text-sm text-ink/55">{subtitle}</p>}
                <div className="mt-8">{children}</div>
            </main>
        </div>
    );
};
